import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "comparison-container mx-5 align-items-center" }
const _hoisted_2 = { class: "option taxFreeCashOption bordered" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = { class: "option noTaxFreeCashOption bordered" }
const _hoisted_6 = { class: "fw-bold" }
const _hoisted_7 = { class: "fw-bold" }


export default /*@__PURE__*/_defineComponent({
  __name: 'DBOptionsLumpSumChoices',
  props: {
        taxFreeCashOption: { type: Object, required: true, default: () => ({ lumpSum: '', annualIncome: '' }) },
        noTaxFreeCashOption: { type: Object, required: true, default: () => ({ lumpSum: '', annualIncome: '' }) }
    },
  setup(__props) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("p", null, "Maximum tax-free lump sum of", -1)),
      _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.taxFreeCashOption.lumpSum), 1),
      _cache[1] || (_cache[1] = _createElementVNode("p", { class: "plus-buffer" }, "Plus", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("p", null, "Initial taxable annual income of", -1)),
      _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.taxFreeCashOption.annualIncome) + " p.a.", 1)
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "option text-center" }, [
      _createElementVNode("h2", null, "or")
    ], -1)),
    _createElementVNode("div", _hoisted_5, [
      _cache[3] || (_cache[3] = _createElementVNode("p", null, "Tax-free lump sum of", -1)),
      _createElementVNode("h2", _hoisted_6, _toDisplayString(__props.noTaxFreeCashOption.lumpSum), 1),
      _cache[4] || (_cache[4] = _createElementVNode("p", { class: "plus-buffer" }, "Plus", -1)),
      _cache[5] || (_cache[5] = _createElementVNode("p", null, "Initial taxable annual income of", -1)),
      _createElementVNode("h2", _hoisted_7, _toDisplayString(__props.noTaxFreeCashOption.annualIncome) + " p.a.", 1)
    ])
  ]))
}
}

})